export interface MenuPortion {
  id: number;
  name: string;
  portionName?: string;
  price: number;
  calories?: number;
  formatedPrice?: string;
}

export interface MenuChoice {
  name: string;
  calories: number;
  price: number;
}

export interface MenuOptionPortion {
  id: number;
  name: string;
  calories?: number;
  price?: number;
  supplementPrice?: number;
}

export interface MenuPromptChoice {
  id: number;
  type: string;
  name: string;
  description?: string;
  children?: unknown[];
  canSelectManyChildren?: boolean;
  isOptionalExtra?: boolean;
  isFeatured?: boolean;
  keywords?: string[];
  portions?: MenuOptionPortion[];
  outOfStock?: boolean;
}

export interface MenuProductOption {
  id: number;
  type: string;
  text?: string;
  name?: string;
  children?: unknown[];
  choices?: MenuPromptChoice[];
  canSelectManyChildren?: boolean;
  isOptionalExtra?: boolean;
  isFeatured?: boolean;
  keywords?: string[];
  portions?: MenuOptionPortion[];
}

export enum MenuChildType {
  PRODUCT = 'PRODUCT',
  IMAGE = 'IMAGE',
  SUBHEADER = 'SUBHEADER',
  TEXTFIELD = 'TEXTFIELD',
}

export interface MenuProduct {
  id: number;
  name: string;
  description?: string;
  imageUrl?: string;
  imageAltText?: string;
  type?: MenuChildType;
  text?: string;
  productType?: string;
  keywords?: string[];
  portions?: MenuPortion[];
  choices?: MenuChoice[];
  options?: (MenuProductOption | null)[];
  canSelectManyChildren?: boolean;
  isOptionalExtra?: boolean;
  outOfStock?: boolean;
}

export interface MenuCategory {
  id: number;
  name: string;
  children: MenuProduct[];
}

export interface MenuItem {
  id: number;
  name: string;
  description?: string;
  tags?: string[];
  menuTree?: MenuCategory[];
  isMapped?: boolean;
}
